<template>
    <div class="homeHeader xy-center">
        <div class="container xy-between">
            <div class="left jf">
                <img v-if="logo" :src="logo" alt="logo"/>
                <img v-else src="../assets/img/headerLogo.png" alt=""/>
                <div class="jf">
                    <div class="font-size22 text">
                        {{ orgName }}
                    </div>
                    <div class="dote"></div>
                    <div class="font-size22 text">
                        {{platformName}}
                    </div>
                </div>
            </div>
            <div class="right">
                <ul class="ulDeltDote font-size16">
<!--                    <li @click="goHome" class="c-2F3134">-->
<!--                        <div>首页</div>-->
<!--                    </li>-->
                    <li v-for="item in navMenu"
                        :key="item.Id"
                        :class="['yx-between', 'c-2F3134', { shouye: item.IsActive}]"
                        @click.stop="navigateByPath(item)">{{ item.Name }}
                        <div class="line"></div>
                    </li>
                    <li class="c-2F3134" @click.stop="handleKetangClick">健康医卫云课堂</li>
                </ul>
                <div class="userInfoBox" style="display: flex; justify-content: flex-end; align-items: center">
                    <div v-if="!isShowUserName" class="userInfo jf">
                        <!-- <div class="avtor"></div> -->
                        <div class="loginText font-size14 c-2F3134">
                            <span @click.stop="loginBtn">登录</span>
                            <span>&nbsp;|&nbsp;</span>
                            <span @click.stop="loginBtn">注册</span>
                        </div>
                    </div>
                    <template v-else>
                        <div class="userInfo jf userInfoHaveLogin">
                            <div class="avtor">
                                <img src="../assets/img/defaulteActor.png" alt=""/>
                            </div>
                            <div class="loginText font-size16 c-2F3134">
                                <div class="UserName one-wrap font-size14">
                                    {{ isPhoneNumber(userInfo.UserName) }}
                                    <i class="el-icon-caret-bottom"></i>
                                </div>
                            </div>
                            <div class="toPersonCenter">
                                <div
                                    class="
                                    font-size14
                                    centerTextBtn
                                    threedary
                                    jf
                                    cursor"
                                    v-for="item in profileRoutes"
                                    :key="item.Code"
                                    @click.stop="routeToPath(item)">
                                    {{item.Name}}
                                </div>
                                <div class="
                                    logOutbtn
                                    font-size14
                                    threedary
                                    jf
                                    cursor"
                                    @click="loginOut">
<!--                                    <i class="el-icon-s-unfold c-32353A"></i>-->
                                    退出
                                </div>
                            </div>
                        </div>
                        <div class="change-user" @click.stop="changeUserRole">
                            <div class="btn">{{ $store.state.userInfo.isManage ? "前往用户端" : "前往管理端" }} <i
                                class="el-icon-sort sort-icon"/></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AdminUserInfo, changeUserRole, loginOut } from "@/api/user";
import { mapState } from "vuex";
import { codeMapModules } from "@/utils/platform-config";
export default {
    props: {
        state: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            isShowHeader: true,
            navMenu: [], // 导航菜单
            isShowDiolog: false
        };
    },
    computed: {
        isShowUserName() {
            return this.$store.state.userInfo != null;
        },
        ...mapState({
            userInfo: state => state.userInfo || {},
        }),
        profileRoutes () {
            return this.$store.state.profileRoutes
        },
        orgName({ userInfo }) {
            return userInfo.OrganName || this.$store.state.groupInfo.Name || this.$store.state.groupInfo.GroupWebName || "朗润数据"
        },
        platformName({ userInfo }) {
            return userInfo.PlatformName || this.$store.state.groupInfo.PlatformName || "医学培训考试服务平台"
        },
        logo ({ userInfo }) {
            return userInfo.Logo || this.$store.state.groupInfo.GroupUserLogo
        }
    },
    mounted() {
        this.getNavMenu();
        this.$bus.$on("pc-login-success", () => {
            window.location.reload()
        })
    },
    beforeDestroy() {
        // this.$bus.$off("pc-login-success", this.getNavMenu)
    },
    methods: {
        /**
         * 获取导航栏菜单
         * @return {Promise<unknown>}
         **/
        async getNavMenu() {
            if (this.$route.path.startsWith("/manage")) return
            const { $route } = this
            const questionActive = $route.path === "/question/organ" ||
                $route.path === "/question/public" ||
                $route.path === "/publicMake" ||
                $route.path === "/question/department"
            // 根据id映射路径和是否需要登录
            const pathAndIsLoginMapByCode = Object.freeze({
                "-100": ["/question/public", this.$store.state.platform === "yixue" ? !this.$store.state.isBindingIp : true, questionActive],
                "-200": ["/exam", true, $route.path === "/exam"],
                "-300": ["/course", true, $route.path === "/course"],
                "-400": ["/psq", true, $route.path === "/psq"],
                "-500": ["/home-medicine", false]
            })
            let navMenu = this.$store.state.navMenu
            if (this.$store.getters.isLogin && this.$store.state.isLoadProfileRoutes === false) {
                await this.$store.dispatch("getPersonCenter")
            }
            if (!this.$store.getters.isLogin && !this.$store.state.isLoadNavMenu) {
                navMenu = await this.$store.dispatch("getNavMenu")
            }
            this.navMenu = navMenu.map(item => Object.assign(item, {
                Path: pathAndIsLoginMapByCode[item.Code][0],
                IsNeedLogin: pathAndIsLoginMapByCode[item.Code][1],
                IsActive: pathAndIsLoginMapByCode[item.Code][2]
            }))
        },
        /**
         * 根据路径导航到不同页面
         * @param item: {
         * Id, Name 导航文字,
         * IsNeedLogin 导航到对应页面之前是否需要提前登录,
         * Path 路径 } item
         * @return {undefined}
         **/
        navigateByPath(item) {
            const { IsNeedLogin, Path } = item
            if (IsNeedLogin) {
                if (this.$store.getters.isLogin) {
                    this.$router.push(Path);
                } else {
                    this.$emit("openLoginDiolog");
                    // this.isShowDiolog = true
                }
            } else {
                this.$router.push(Path);
            }
        },
        async goOut() {
            try {
                const { data } = await loginOut();
                this.$store.commit("setUser", null);
                this.$store.commit("setUserInfo", null);
                // this.$router.replace("/")
                window.location.href = window.location.pathname
            } catch (err) {
                console.log(err);
            }
        },
        goTopicLibary() {
            this.$router.push("/question/public");
        },
        goHome() {
            this.$router.push("/");
        },
        loginBtn() {
            this.$emit("openLoginDiolog");
        },
        routeToPath (item) {
            const isManage = this.$store.state.userInfo?.isManage
            if (codeMapModules[item.Code].enName === "profile-module" && isManage) {
                this.$router.push("/manage")
            } else {
                this.$router.push(item.Path)
            }
        },
        isPhoneNumber(tel) {
            var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
            if (reg.test(tel)) {
                tel = tel.substr(0, 3) + "****" + tel.substr(7);
                return tel;
            } else {
                return tel;
            }
        },
        goExam() {
            if (this.$store.getters.isLogin) {
                this.$router.push("/exam");
            }

        },

        loginOut() {
            this.$confirm(`是否确认退出${this.$store.state.userInfo.PlatformName}?`, "提示", {
                confirmButtonText: "确认退出",
                cancelButtonText: "我再想想",
                type: "warning",
            })
                .then(() => {
                    this.goOut();
                })
                .catch(() => {
                });
        },
        // 切换用户角色
        changeUserRole() {
            changeUserRole(1).then(res => {
                this.$store.commit("setUser", res);
                this.getAdminUserInfo()
            })
        },
        handleKetangClick () {
            window.open("https://zhiye.cqvip.com/course/jkyw", "__blank")
        },
        getAdminUserInfo() {
            AdminUserInfo().then((res) => {
                if (res.data.code === 100) {
                    res.data.data.isManage = true;
                    this.$store.commit("setUserInfo", res.data.data);
                    this.$router.setManageRouteOfServer().then(() => {
                        this.$store.commit("clearPersonCenter")
                        window.location.href = window.location.pathname
                    });
                } else {
                    this.$message.error("获取用户信息失败");
                }
            });
        }

    },
};
</script>

<style scoped lang="less">
.homeHeader {
    width: 100%;
    height: 70px;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    background: white;
    box-shadow: rgb(204, 204, 204) 1px 1px 11px;

    .container {
        width: 62.5%;
        height: 100%;

        .left {
            img {
                width: 25px;
                margin-right: 10px;
            }

            .dote {
                background-color: black;
            }

            .text {
                font-size: 22px;
                font-weight: 600;
            }
        }

        .right {
            height: 100%;
            color: white;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .ulDeltDote {
                padding: 0;
                display: flex;
                align-items: center;

                li {
                    cursor: pointer;
                    text-align: center;
                    font-size: 16px;
                    margin-right: 20px;
                }

                .shouye {
                    color: #256cf4;

                    .line {
                        width: 20px;
                        height: 6px;
                        background: #256cf4;
                        border-radius: 3px;
                    }
                }
            }

            .userInfoBox {
                min-width: 300px;
            }

            .userInfo {
                .avtor {
                    margin-right: 5px;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    background: #efefef;
                    border: 1px solid #ffffff;

                    img {
                        width: 100%;
                    }
                }

                .loginText {
                    cursor: pointer;
                }

                .UserName {
                    max-width: 200px;
                }
            }

            .userInfoHaveLogin {
                position: relative;
                height: 69px;

                .toPersonCenter {
                    display: none;
                    min-width: 130px;
                    background-color: white;
                    position: absolute;
                    top: 55px;
                    right: 0;
                    border-radius: 6px;

                    .centerTextBtn {
                        width: 100%;
                        height: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        border-bottom: 1px solid #f0f3f7;
                        display: block;
                        text-align: center;

                        i {
                            margin-right: 10px;
                        }
                    }

                    .centerTextBtn:hover {
                        background-color: #f0f3f7;
                    }

                    .logOutbtn {
                        width: 100%;
                        height: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        display: block;
                        text-align: center;

                        i {
                            margin-right: 10px;
                        }
                    }

                    .logOutbtn:hover {
                        background-color: #f0f3f7;
                    }
                }
            }

            .userInfoHaveLogin:hover .toPersonCenter {
                display: block;
                box-shadow: 0px 2px 40px 0px rgba(229, 232, 236, 0.8);
            }
        }
    }
}

.change-user {
    margin-left: 30px;

    .btn {
        padding: 9px 8px;
        color: #0C95FD;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
        border: 1px solid #0C95FD;
        border-radius: 6px;
        transition: color .3s, background-color .3s;

        .sort-icon {
            transform: rotate(90deg);
            margin-left: 8px;
        }

        &:hover {
            background-color: #0C95FD;
            color: #fff;
        }
    }
}
</style>
